export const DARK_MODE_STORAGE_KEY = 'dark-mode';
